import React from "react";
import Card from "src/componets/Card";
import { AppInterface } from "src/store/community/appsSlice";
import RowInfo from "../../../../componets/RowInfo";

const _Details = ({ app }: { app: AppInterface | undefined }) => {
  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>App credentials</h4>

        <div style={{ maxWidth: 600 }}>
          <RowInfo left='UID' right={app?.uid} />
          <RowInfo left='JWT' right={app?.jwt_secret} />
        </div>
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Notes</h4>
        {app?.notes}
      </Card>
    </>
  );
}

export default _Details;
